import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';

import { Product } from '../interfaces/product.model';
import { GoogleMapService } from '../providers/google-map.service';
import { StateService } from '../providers/state.service';
import { Store } from '../interfaces/store.model';

@Injectable({ providedIn: 'root' })
export class StoreDetailsResolver implements Resolve<Product[]> {
    storeName: string;
    storeAddress: string;
    store: Store;
    product: Product;

    constructor(private gmapSvc: GoogleMapService, private router: Router, private stateSvc: StateService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        this.store = this.stateSvc.getStore();
        this.product = this.stateSvc.getProduct();
        this.storeName = this.store.store_name;
        this.storeAddress = this.store.store_address;
        return from(this.gmapSvc.getPlaceId(this.store.retailer, this.storeAddress, this.storeName).pipe(
            mergeMap(placeId => {
                return this.gmapSvc.getPlaceDetail(placeId.candidates[0].place_id).pipe(
                    map(geoStore => {
                        return {
                            geoInfo: geoStore
                        };
                    })
                );
            }),
        ));
    }

}
